import { z } from 'zod';

export const HackeroneWebhookEventSchema = z.string().min(1);

const HackeroneWebhookProgramSchema = z.looseObject({
  handle: z.string().min(1).nullish(),
});

const HackeroneWebhookReportSchema = z.looseObject({
  id: z.string().min(1),
});

export const HackeroneWebhookPayloadSchema = z.looseObject({
  data: z.looseObject({
    activity: z
      .looseObject({
        type: z.string().min(1).nullish(),
      })
      .optional(),
    report: HackeroneWebhookReportSchema.optional(),
    relationships: z
      .looseObject({
        program: z
          .looseObject({
            data: HackeroneWebhookProgramSchema.optional(),
          })
          .optional(),
      })
      .optional(),
  }),
});

export type HackeroneWebhookPayload = z.infer<
  typeof HackeroneWebhookPayloadSchema
>;

export const extractHackeroneWebhookReportId = ({
  payload,
}: {
  payload: HackeroneWebhookPayload;
}): string | null => payload.data.report?.id ?? null;

export const extractHackeroneWebhookProgramHandle = ({
  payload,
}: {
  payload: HackeroneWebhookPayload;
}): string | null =>
  payload.data.relationships?.program?.data?.handle?.trim() || null;
